import React, { Component } from 'react';
import closeIcon from 'Icons/close-icon.png';


class Header extends Component {

  render() {
    return (
      <div className="sc-header">
        <img className="sc-header--img" src={this.props.imageUrl} alt="" />
        <div className="sc-header--team-name"> 
          <span>{this.props.teamName} </span>
          {this.props.caption && <span className="white-color ml-5 fRegular fs-12 op-79 lh-15p"> {this.props.caption} </span>}
        </div>
        <div className="sc-header--close-button" onClick={this.props.onClose}>
          <img src={closeIcon} alt="" />
        </div>
      </div>
    );
  }
}

export default Header;
